'use client';

import { Suspense, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

function GoogleAnalyticsTracker({ gaId }: { gaId: string }) {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	useEffect(() => {
		if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
			const query = searchParams?.toString();
			const pagePath = pathname + (query ? `?${query}` : '');
			window.gtag('config', gaId, {
				page_path: pagePath,
				page_location: window.location.href,
			});
		}
	}, [pathname, searchParams, gaId]);

	return null;
}

export function GoogleAnalyticsPageView({ gaId }: { gaId: string }) {
	return (
		<Suspense fallback={null}>
			<GoogleAnalyticsTracker gaId={gaId} />
		</Suspense>
	);
}
